import * as React from "react"
export const Svg_026 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="m35.948 20.864-3.304-2.22a1.65 1.65 0 0 0-.922-.281c-.524 0-1.039.245-1.355.701l-.02.03a1.58 1.58 0 0 0-.258 1.206c.08.423.324.79.685 1.033l3.304 2.22a1.65 1.65 0 0 0 1.227.254 1.63 1.63 0 0 0 1.05-.674l.02-.03c.248-.355.34-.783.258-1.206a1.597 1.597 0 0 0-.685-1.032Z"
      />
      <path
        fill="url(#c)"
        d="m28.898 31.157-3.304-2.221a1.65 1.65 0 0 0-.922-.28c-.524 0-1.038.245-1.355.7l-.021.031a1.596 1.596 0 0 0 .429 2.238l3.304 2.221a1.65 1.65 0 0 0 1.227.253 1.63 1.63 0 0 0 1.05-.674l.02-.029a1.598 1.598 0 0 0-.428-2.24Z"
      />
      <path
        fill="url(#d)"
        d="M59.867 8.181a5.151 5.151 0 0 0-2.202-3.324L51.86.905c-2.406-1.617-5.7-1.008-7.345 1.357l-5.493 7.902-16.804-2.596L.04 40.012 28.29 59 50.47 26.55 41.92 12.112l1.51-2.171a1.764 1.764 0 0 1 1.136-.73c.466-.087.938.01 1.32.268l5.805 3.952a5.31 5.31 0 0 0 3.959.817 5.257 5.257 0 0 0 3.386-2.174 5.093 5.093 0 0 0 .831-3.893ZM23.155 48.596l-2.899-1.948 1.602-2.304-4.396-2.955a5.845 5.845 0 0 1-.966 2.337l-.187.269-2.899-1.948.187-.269c.378-.544.518-1.2.395-1.847a2.447 2.447 0 0 0-1.05-1.58l1.982-2.85.005.004 8.91 5.99 1.601-2.304 2.899 1.948-5.184 7.457Zm9.07-13.252-.02.03a5.122 5.122 0 0 1-3.3 2.118 5.173 5.173 0 0 1-3.857-.796l-3.304-2.22c-2.344-1.576-2.948-4.733-1.346-7.038l.022-.03c1.601-2.304 4.811-2.898 7.155-1.322l3.304 2.22a5.025 5.025 0 0 1 2.155 3.245 4.964 4.964 0 0 1-.81 3.793Zm7.049-10.292-.02.029a5.122 5.122 0 0 1-3.3 2.119 5.174 5.174 0 0 1-3.857-.796l-3.304-2.221a5.024 5.024 0 0 1-2.155-3.245 4.963 4.963 0 0 1 .81-3.792l.02-.03c1.602-2.304 4.813-2.898 7.157-1.322l3.304 2.22a5.025 5.025 0 0 1 2.154 3.245 4.963 4.963 0 0 1-.809 3.793Zm16.864-14.926a1.793 1.793 0 0 1-2.457.461l-5.805-3.952a5.333 5.333 0 0 0-1.636-.738l1.173-1.687a1.793 1.793 0 0 1 2.457-.461L55.675 7.7c.391.263.655.66.742 1.118a1.71 1.71 0 0 1-.279 1.307Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={31.587}
        x2={33.945}
        y1={19.184}
        y2={23.789}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={24.538}
        x2={26.896}
        y1={29.476}
        y2={34.081}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.896}
        x2={41.725}
        y1={8.85}
        y2={54.591}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h60v59H0z" />
      </clipPath>
    </defs>
  </svg>
)